import { Button } from "@mui/material";
import { useNavigate } from "react-router";
import { paths } from "@rms-types/constants/paths";

import { ViewWrapper } from "..";

import Image from "@/assets/svgs/error-403.svg";

export function Error403() {
  const navigate = useNavigate();

  return (
    <ViewWrapper
      title="403: Forbidden"
      subtitle="You either tried some shady route or you came here by mistake. Whichever it is, try using the navigation."
      image={Image}
      action={
        <Button variant="outlined" color="primary" onClick={() => navigate(paths.app.dashboard.path)}>
          Back to Home
        </Button>
      }
    />
  );
}
